import * as React from 'react';
const AddIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.667a.5.5 0 0 1 .5.5V9.5h5.333a.5.5 0 0 1 0 1H10.5v5.334a.5.5 0 1 1-1 0V10.5H4.167a.5.5 0 0 1 0-1H9.5V4.167a.5.5 0 0 1 .5-.5"
      fill="currentColor"
    />
  </svg>
);
export default AddIcon;
